export const useSxStyles = () => {
  return {
    content: { display: 'grid', padding: 0, maxHeight: 'calc(90vh - 70px)' },
  };
};
